/**
 * Proficiency level for program concepts and competencies
 */
export enum ProficiencyLevel {
  DISCOVER = 'DISCOVER',
  CONSOLIDATE = 'CONSOLIDATE',
  MASTER = 'MASTER',
}
